import { Component, Input, OnInit } from '@angular/core'

@Component({
	selector: 'app-b2b-benefits',
	templateUrl: './b2b-benefits.component.html',
	styleUrls: ['./b2b-benefits.component.scss'],
})
export class B2bBenefitsComponent implements OnInit {
	@Input() data: any = {}

	icons = [
		'assets/images/b2b-benefits/icon-compras-recorrentes.svg',
		'assets/images/b2b-benefits/icon-fluxos-administrativos.svg',
		'assets/images/b2b-benefits/icon-dependencia-fornecedores.svg',
		'assets/images/b2b-benefits/icon-armazenamento-galoes.svg',
		'assets/images/b2b-benefits/icon-consumo-plastico.svg',
	]

	slideConfig = {
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		mobileFirst: true,
		swipeToSlide: true,
		variableWidth: true,
		touchThreshold: 4,
	}

	constructor() {}

	ngOnInit(): void {}
}
